import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Countdown from "@/components/Countdown";
import { ProductGridSkeleton } from "@/components/Skeletons";
import { Zap } from "lucide-react";

export default function Drops() {
  const [drops, setDrops] = useState(null);
  useEffect(() => {
    api.get("/drops").then((r) => setDrops(r.data.drops));
  }, []);

  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-12" data-testid="drops-page">
      <div className="border-y-2 border-[#FF3B30] py-12 mb-12">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <div>
            <div className="font-mono text-xs text-[#FF3B30] tracking-widest flex items-center gap-2"><Zap size={14}/> LIVE DROP</div>
            <h1 className="font-display text-7xl md:text-9xl tracking-tighter mt-2 leading-[0.85]">DROP <span className="text-[#FF3B30]">014</span></h1>
            <p className="text-black/60 mt-4 max-w-xl">Limited release. 500 pieces. Once it's gone, it's gone.</p>
          </div>
          {drops?.[0]?.drop_release_at && <Countdown targetIso={drops[0].drop_release_at} />}
        </div>
      </div>
      {drops === null ? (
        <ProductGridSkeleton />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {drops.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
